import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import SessionForm from './SessionForm';
import Session from './Session';
import IncidentForm from './IncidentForm';

const SessionManager = observer(class SessionManager extends React.Component {
  constructor() {
    super();
    this.cancelAdd = this.cancelAdd.bind(this);
    this.completeIncident = this.completeIncident.bind(this);
  }

  componentWillMount() {
    this.state = {
      minimized: [],
      installSid: null,
      examSid: null,
      courseSid: null,
      schedulingModule: null,
      hideForm: true
    }

    // Enable multi-session adding button if it’s allowed
    if(this.props.multi) {
      this.props.store.ManagerStore.multi = true;
    }

    // If there’s a session sid in the URL, get that session
    if(this.props.routing.location.query.code) {
      this.props.store.ManagerStore.getSession(this.props.routing.location.query.code, this);
    }
  }

  componentDidMount() {
    const _this = this;

    // Prevents add session and incident form animations from playing on load
    setTimeout(function(){
      _this.setState({
        hideForm: false
      });
    });
  }

  maximize(accessKey) {
    let minimized = [...this.state.minimized];
    const index = minimized.indexOf(accessKey);
    minimized.splice(index, 1);
    this.setState({
      minimized
    });
  }

  cancelAdd() {
    this.props.store.ManagerStore.addSession = false;
    this.props.store.ManagerStore.reportIncident = false;
  }

  completeIncident() {
    const { translation } = this.props;

    this.props.store.ManagerStore.reportIncident = false;
    this.props.store.ManagerStore.incidentSession = null;

    this.props.store.SessionStore.showToaster(translation.incident_saved, 'success');
  }

  render() {
    const { translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;
    const { sessions } = ManagerStore;

    let sessionSid = null;

    if(this.props.routing.location.query.code) {
      sessionSid = this.props.routing.location.query.code;
    }

    return(
      <main tabIndex="0" id="main-content" className="page wrap">
        {/* Show the intro and lookup form if there are no sessions being viewed */}
        {!SessionStore.loading && sessions.length === 0 && !sessionSid &&
          <div className="panel--brief">
            <h1 className="panel__title">{translation.page_title}</h1>
            <p>{translation.intro}</p>

            <SessionForm parent={this} {...this.props} />
          </div>
        }

        {sessions.length > 0 &&
          <ul className="block-list session-list">
            {sessions.map(
              (session, i) =>
              {
                if(typeof session.enrollment !== 'undefined' && typeof session.exam !== 'undefined') {
                  return (
                    <Session
                      key={i}
                      session={session}
                      minimize={this.state.minimized.indexOf(session.accessKey) >= 0}
                      parent={this}
                      installSid={this.state.installSid}
                      courseSid={this.state.courseSid}
                      examSid={this.state.examSid}
                      schedulingModule={this.state.schedulingModule}
                      {...this.props}
                    />
                  )
                }

                return null;
              }
            )}
          </ul>
        }

        {this.state.minimized.length > 0 &&
          <ul className="minimized">
            {this.state.minimized.map(
              (session, i) =>
              <li key={i}>
                <article className="minimized__tab">
                  <span className="minimized__title">{session}</span>
                  <button
                    className="minimize__btn"
                    onClick={() => {this.maximize(session)}}
                  >
                    <span className="meta">{translation.maximize}</span>
                  </button>
                </article>
              </li>
            )}
          </ul>
        }

        {this.props.multi &&
          <div className={`session-interact ${this.state.hideForm ? 'hidden' : ''} ${ManagerStore.addSession ? 'active' : ''}`}>
            <div className="panel--brief">
              <h2>{translation.add_session}</h2>

              {ManagerStore.addSession &&
                <SessionForm parent={this} {...this.props} />
              }

              <button className="btn--link" onClick={this.cancelAdd}>{translation.cancel}</button>
            </div>
          </div>
        }

        <div className={`session-interact ${this.state.hideForm ? 'hidden' : ''} ${ManagerStore.reportIncident ? 'active' : ''}`}>
          <div className="panel--brief">
            <h2>{translation.report_incident}</h2>

            {ManagerStore.reportIncident &&
              <IncidentForm
                installSid={this.state.installSid}
                examSid={this.state.examSid}
                completeIncident={this.completeIncident}
                {...this.props}
              />
            }

            <button className="btn--link" onClick={this.cancelAdd}>{translation.cancel}</button>
          </div>
        </div>
      </main>
    )
  }
})

export default translate('SessionManager')(SessionManager);


// WEBPACK FOOTER //
// ./src/app/components/Outside/SessionManager.js